import React, { FunctionComponent } from "react";
import DataSheetPrintOptions from "./DataSheetPrintOptions";
import DataSheetViewOptions from "./DataSheetViewOptions";

const DataSheetOptionsTab: FunctionComponent = function DataSheetOptionsTab() {
	return (
		<>
			<DataSheetViewOptions />
			<DataSheetPrintOptions />
		</>
	);
};

export = DataSheetOptionsTab;